export default "December 6, 2019";